module.exports = __webpack_public_path__ + "static/media/4652dd4a5d3aa12d8c22115cdb260943_html_687a086d3b6003fa.1d5bd2f4.png";